import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

import { LOGIN_PAGES } from 'src/app/routes/login-process/enum-login-pages';

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss'],
})
export class LoginModalComponent implements OnInit {
  currentStep: number = LOGIN_PAGES.EMAIL;
  email = '';
  applicationType = '';

  constructor(private config: DynamicDialogConfig) {}

  ngOnInit(): void {
    this.currentStep = this.config.data?.step;
    this.email = this.config.data?.email;
    this.applicationType = this.config.data?.application_type
      ? this.config.data?.application_type
      : 'dashboard';
  }
}
